// extracted by mini-css-extract-plugin
export default {"card":"Bigcard_card__kim+Q","smallImg":"Bigcard_smallImg__cwJBi","bigImg":"Bigcard_bigImg__xdlrI"};